export default __webpack_public_path__ + "static/media/8.6eaee257.png";